
export class CsvConfiguration {
columnSeparator: string;
withHeader: boolean;
}

